import { render, staticRenderFns } from "./CompanyDrawerSpecialDataTab.vue?vue&type=template&id=5868c138&"
import script from "./CompanyDrawerSpecialDataTab.vue?vue&type=script&lang=ts&"
export * from "./CompanyDrawerSpecialDataTab.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyDrawerSpecialDataTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports